import React from 'react';

export const ClientRole = {};
export const ChannelProfile = {};
export const RtcEngine = {};
const video =
  'https://firebasestorage.googleapis.com/v0/b/barhuntv2.appspot.com/o/hosting%2FUntitled%20(3).mp4?alt=media&token=53815a79-df80-4833-af66-a9b5bfe2e48e';
export const RtcSurfaceView = ({style = {}}) => {
  console.log('redendering SurfaceView');
  return (
    <video
      src={video}
      muted
      loop
      autoPlay
      style={{
        objectFit: 'cover',
        ...style,
      }}
    />
  );
};

export default RtcEngine;
